import { all } from 'redux-saga/effects';
import accounts from "./accounts";
import user from './user';

const sagas = function* sagas() {
  yield all([
    user(),
	accounts()
  ]);
};

export default sagas;
